<template>
  <v-container fluid fill-height>
    <v-row
      justify="center"
      align="center"
    >
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-10 py-5 px-3 login-card">
          <v-card-title class="justify-center body-1">
            <strong>LOGIN</strong>
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-text-field 
                :error-messages="$v.fieldn.$invalid ? ['Digite um email válido'] : []"
                name="username"
                id="username"
                v-model="fieldn"
                prepend-inner-icon="mdi-email-outline"
                label="Email"
                outlined
                dense
                clearable
                class="mb-4"
              ></v-text-field>

              <v-text-field
                :disabled="$v.fieldn.$invalid"
                prepend-inner-icon="mdi-lock-outline"
                v-model="fieldp"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="password"
                id="password"
                label="Senha"
                outlined
                clearable
                @click:append="show1 = !show1"
                v-on:keyup.enter="login()"
                dense
                class="mb-4"
              ></v-text-field>

              <span class="my-login-error">{{ loginMessage }}</span>

              <v-btn 
                :disabled="dialogLoader || $v.fieldp.$invalid" 
                width="100%" 
                large 
                class="primary mb-4" 
                @click="login"
              >
                Login
              </v-btn>

              <v-btn 
                :disabled="dialogLoader" 
                width="100%" 
                large 
                class="secondary mb-4" 
                to="novaConta"
              >
                Criar Conta
              </v-btn>

              <v-divider></v-divider>

              <v-btn 
                text 
                outlined 
                class="mt-4 forgot-password-btn"
                @click="openWebLogin()" 
                small
                v-if="!$v.fieldn.$invalid"
              >
                Esqueci minha senha
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Aguarde...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import HOST from '../ws';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  axios,
  beforeMount() {
    var storage = window.localStorage;
    this.storedUsername = storage.getItem('username');

    if (this.storedUsername && this.storedUsername.length > 0) {
      this.storedPassword = storage.getItem('password');
      this.fieldn = this.storedUsername;
      this.fieldp = this.storedPassword;
      this.login();
    }
  },
  props: {
    source: String
  },
  data: () => ({
    myHost: HOST.HOST,
    errors: [],
    show1: false,
    fieldn: '',
    fieldp: '',
    loginMessage: '',
    dialogLoader: false,
    storedUsername: null,
    storedPassword: null,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 4 || "Min 4 characters",
      emailMatch: () => "The email and password you entered don't match"
    }
  }),
  methods: {
    openWebLogin() {
      this.$store.commit("setDialogRecoverPwd", true);
    },
    login() {
      this.dialogLoader = true;
      const formData = new FormData();
      formData.append('grant_type', 'password');
      formData.append('username', this.fieldn);
      formData.append('password', this.fieldp);

      this.axios.post(this.myHost + '/oauth/token', formData, {
        auth: {
          username: 'client',
          password: '123'
        }
      }).then((response) => {
        this.$store.commit('addToken', response.data.access_token);

        this.axios({
          method: 'post',
          url: this.myHost + '/user/userbyemail',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`
          },
          data: this.fieldn
        }).then((response) => {
          this.$store.commit('addUserLogged', response.data);

          var storage = window.localStorage;
          storage.setItem('username', this.fieldn);
          storage.setItem('password', this.fieldp);

          this.axios({
            method: 'post',
            url: this.myHost + '/assinatura/allbyuserlogged/' + this.$store.getters.userLogged.id,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.$store.state.currentToken}`
            },
            data: this.fieldn
          }).then((response2) => {
            this.$store.commit('updateAssinaturas', response2.data);

            const config = {
              headers: { Authorization: `Bearer ${this.$store.state.currentToken}` },
            };
            this.axios.get(this.myHost + '/api/reports-app/count-treinos-my', config).then(response3 => {
              console.log("total de treinos : " + response3.data);
              this.$store.commit('setMyTotalTreinoCount', response3.data);
            });
          });

          this.dialogLoader = false;
          if(this.$store.getters.userLogged && this.$store.getters.userLogged.roleAdmin){
            //this.$router.push("treinosDodia");
            this.$router.push("dailyResume");
          } else if(this.$store.getters.myTotalTreinoCount > 10){
            this.$router.push("chartPageAluno");
          }else{
            this.$router.push("noticias");
          }
        });
      }).catch((error) => {
        console.log(error.message);
        this.loginMessage = 'Usuário e senha não conferem';
        this.dialogLoader = false;
      });
    }
  },
  validations: {
    fieldn: {
      required,
      email,
      minLength: minLength(8)
    },
    fieldp: {
      required,
      minLength: minLength(4)
    }
  }
};
</script>

<style scoped>
.login-card {
  border-radius: 12px;
  background-color: #f9f9f9;
}

.primary {
  background-color: #4CAF50;
  color: white;
}

.secondary {
  background-color: #607D8B;
  color: white;
}

.my-login-error {
  color: #F06B34;
  font-weight: bold;
}

.forgot-password-btn {
  color: #1E88E5;
}
</style>
